const PAYLUDD_SUBSCRIPTIONS = {
    COLLECTION: {
        url: '/payluddPosTerminals',
        queryKey: 'getPayluddSubscriptions'
    },
    MERCHANT_ACCOUNT_COLLECTION: {
        url: '/contractsAccesses/:contractAccessId/posTerminalsData',
        queryKey: 'getPayluddMerchantAccountSubscriptions'
    },
    EMERGENCY_REMOTE_COLLECTION_CONTRACTS: {
        url: '/posTerminals/:uuid/emergencyRemoteCollectionContracts',
        queryKey: 'getEmergencyRemoteCollectionContracts'
    },
    EMERGENCY_REMOTE_COLLECTION_TRANSACTIONS_SUMMARY: {
        url: '/posTerminals/:uuid/emergencyRemoteCollectionTransactionsSummary'
    },
    EMERGENCY_REMOTE_COLLECTION_TRIGGER: {
        url: '/posTerminals/:uuid/triggerEmergencyRemoteCollection'
    },
    EXPORT_POS_TERMINALS_PAYLUDD: {
        url: '/payluddPosTerminals/export'
    },
    TERMINATE: {
        url: '/payluddPosTerminals/:subscriptionId/terminate'
    }
};
export default PAYLUDD_SUBSCRIPTIONS;